<template>
  <article>
    <section class="xbed-sub-title">
      <span>退款单列表</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>退款单列表</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section style="margin-top:20px">
      <Form :model="search" inline>
        <FormItem  label="创建日期：" prop="createDate" :label-width="84">
          <DatePicker v-model="defaultDate" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 220px"></DatePicker>
        </FormItem>
        <FormItem label="订单号：" :label-width="105">
          <Input v-model="search.orderNo" placeholder="请输入订单号查询"></Input>
        </FormItem>
        <FormItem label="退款原因：" :label-width="110">
          <Select v-model="search.refundRea" transfer filterable>
            <Option :value="0">全部</Option>
            <Option :value="1">OMS操作</Option>
            <Option :value="2">人工建单</Option>
            <Option :value="3">用户操作</Option>
            <Option :value="4">系统退款</Option>
            <Option :value="5">OTA操作</Option>
          </Select>
        </FormItem>
        <FormItem label="退款状态：" :label-width="84">
          <Select v-model="search.refundStat" transfer filterable>
            <Option :value="0">全部</Option>
            <Option :value="1">待退款</Option>
            <Option :value="2">已退款</Option>
            <Option :value="3">已取消</Option>
            <Option :value="4">退款中</Option>
          </Select>
        </FormItem>
        <FormItem label="退款方式：" :label-width="84">
          <Select v-model="search.refundWay" transfer filterable>
            <Option :value="0">全部</Option>
            <Option :value="1">Xbed原路退款</Option>
            <Option :value="2">线下退款</Option>
            <Option :value="3">OTA退款</Option>
          </Select>
        </FormItem>
        <FormItem label="退款类型" :label-width="84">
          <Select v-model="search.refundType" transfer filterable>
            <Option :value="0">全部</Option>
            <Option :value="1">提前退房</Option>
            <Option :value="2">换房差价</Option>
            <Option :value="3">取消订单</Option>
            <Option :value="4">增值服务</Option>
            <Option :value="6">短租押金</Option>
            <Option :value="7">长租押金</Option>
            <Option :value="8">手动取消入账单</Option>
            <Option :value="9">超时支付</Option>
            <Option :value="10">重复支付</Option>
            <Option :value="5">其他</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="84">
          <Button type="primary" @click="conditionSearch">查询</Button>
        </FormItem>
        <FormItem :label-width="84">
          <Button type="primary" @click="addNewRefund">新建退款单</Button>
        </FormItem>
        <FormItem :label-width="84">
          <Button type="primary" @click="exportExcel">导出excel</Button>
        </FormItem>
      </Form>
      <br>
      <Table stripe :columns="column" :data="refund.list"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="refund.count" :current="refund.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </section>
    <Modal ref="refundModal" :loading="true" v-model="modalCtr.refundModal.display" title="手动退款信息" @on-ok="subRefundInfo">
      <Form>
        <FormItem label="退款状态：" :label-width="100">
          <Input type="text" disabled :value="modalCtr.refundModal.data.stat"></Input>
        </FormItem>
        <FormItem label="退款单金额：" :label-width="100">
          <Input type="text" disabled :value="modalCtr.refundModal.data.refundAmout"></Input>
        </FormItem>
        <FormItem label=" " :label-width="100">
          <RadioGroup v-model="modalCtr.refundModal.data.changeMoney">
            <Radio label="1">确认退款金额</Radio>
            <Radio label="2">调整退款金额</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="modalCtr.refundModal.data.changeMoney==2" label="实退金额：" :label-width="100">
          <Input type="text" v-model="modalCtr.refundModal.data.activeMoney"></Input>
        </FormItem>
        <FormItem label="退款方式" :label-width="100">
          <Select v-model="modalCtr.refundModal.data.refundChannel" transfer>
            <Option value="1">Xbed原路退款</Option>
            <Option value="2">线下退款</Option>
            <Option value="3">OTA退款</Option>
          </Select>
        </FormItem>
        <FormItem v-if="modalCtr.refundModal.data.refundChannel==2" label="收款渠道" :label-width="100">
          <Select v-model="modalCtr.refundModal.data.receiveSource" transfer>
            <Option value="微信">微信</Option>
            <Option value="支付宝">支付宝</Option>
            <Option value="银联">银联</Option>
            <Option value="线下">线下</Option>
          </Select>
        </FormItem>
        <FormItem v-if="((modalCtr.refundModal.data.refundChannel==2)&&((modalCtr.refundModal.data.receiveSource=='微信') || (modalCtr.refundModal.data.receiveSource=='线下')))" label=" " :label-width="100">
          <Input type="text" :value="modalCtr.refundModal.data.tip" disabled></Input>
        </FormItem>
        <FormItem v-if="((modalCtr.refundModal.data.refundChannel==2)&&(modalCtr.refundModal.data.receiveSource=='支付宝'))" label="账号" :label-width="100">
          <Input type="text" v-model="modalCtr.refundModal.data.aliPay"></Input>
        </FormItem>
        <FormItem v-if="((modalCtr.refundModal.data.refundChannel==2)&&(modalCtr.refundModal.data.receiveSource=='银联'))" label="银行" :label-width="100">
          <Input type="text" v-model="modalCtr.refundModal.data.bankName"></Input>
        </FormItem>
        <FormItem v-if="((modalCtr.refundModal.data.refundChannel==2)&&(modalCtr.refundModal.data.receiveSource=='银联'))" label="银行卡号" :label-width="100">
          <Input type="text" v-model="modalCtr.refundModal.data.bankCount"></Input>
        </FormItem>
        <FormItem label="财务备注" :label-width="100">
          <Input v-model="modalCtr.refundModal.data.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal ref="addRefundModal" :loading="true" v-model="modalCtr.addRefundModal.display" title="新建退款单" @on-ok="subNewRefund">
      <Form ref="addNewRefundForm" :model="modalCtr.addRefundModal.data" :rules="modalCtr.addRefundModal.validate">
        <FormItem label="订单号" prop="orderNo" :label-width='80'>
          <Input v-model="modalCtr.addRefundModal.data.orderNo"></Input>
        </FormItem>
        <FormItem label="退款类型" prop="refundType" :label-width='80'>
          <Select v-model="modalCtr.addRefundModal.data.refundType" transfer>
            <Option value="1">提前退房</Option>
            <Option value="2">换房差价</Option>
            <Option value="3">取消订单</Option>
            <Option value="6">短租押金</Option>
            <Option value="7">长租押金</Option>
            <Option value="8">手动取消入账单</Option>
            <Option value="9">超时支付</Option>
            <Option value="5">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="金额" prop="price" :label-width='80'>
          <Input v-model="modalCtr.addRefundModal.data.price"></Input>
        </FormItem>
        <FormItem label="原因" prop="reason" :label-width='80'>
          <Input v-model="modalCtr.addRefundModal.data.reason" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal ref="cancelModal" :loading="true" v-model="modalCtr.cancelModal.display" title="取消退款单" @on-ok="subCancel">
      <Form ref="cancelRefundForm" :model="modalCtr.cancelModal.data" :rules="modalCtr.cancelModal.validate">
        <FormItem label=" " :label-width='80' prop="tips1">
          <Input v-model="modalCtr.cancelModal.data.tips1" disabled></Input>
        </FormItem>
        <FormItem label=" " :label-width='80' prop="tips2">
          <Input v-model="modalCtr.cancelModal.data.tips2" disabled></Input>
        </FormItem>
        <FormItem label=" " :label-width='80' prop="remark">
          <Input v-model="modalCtr.cancelModal.data.remark" type='textarea' :autosize='{minRows: 2,maxRows: 5}'>该操作不可恢复，请谨慎操作</Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import Config from "@/config";
import API from "@/api";
//import {STORE_KEY} from "../../constants";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryRefundsList();
  },
  data() {
    return {
      defaultDate: [Moment().subtract(7,'days').format('YYYY-MM-DD'), Moment().format('YYYY-MM-DD')],
      modalCtr: {
        refundModal: {
          display: false,
          data: {
            id: "",
            sourceId: "",
            payType: "",
            stat: "",
            activeMoney: "",
            refundChannel: "1", //
            receiveSource: "微信", //
            aliPay: "",
            bankName: "",
            bankCount: "",
            remark: "",
            receiveAccount: "",
            refundAmout: "",
            tip: "如有需要，请在备注中记录收款信息",
            activeMoneyInt: 0,
            refundAmoutInt: 0,
            changeMoney: 1 //是否确认退款金额
          },
          defaultData: {
            id: '',
            sourceId: '',
            payType: "",
            stat: "",
            activeMoney: "",
            refundChannel: "1", //
            receiveSource: "微信", //
            aliPay: "",
            bankName: "",
            bankCount: "",
            remark: "",
            receiveAccount: "",
            refundAmout: "",
            tip: "如有需要，请在备注中记录收款信息",
            activeMoneyInt: 0,
            refundAmoutInt: 0,
            changeMoney: 1 //是否确认退款金额
          }  
        },
        addRefundModal: {
          display: false,
          data: {
            orderNo: '',
            refundType: '',
            price: '',
            reason: '',
            createType: 2,
            priceInt: ''
          },
          defaultData: {
            orderNo: '',
            refundType: '',
            price: '',
            reason: '',
            createType: 2,
            priceInt: ''
          },
          validate: {
            orderNo: [
              {required: true, message: '请填写订单号', trigger: 'blur'},
              {pattern: /^[0-9]*$/, message: '订单号不正确', trigger: 'blur'}
            ],
            refundType: [
              {required: true, message: '请选择退款类型', trigger: 'blur'}
            ],
            price: [
              {required: true, message: '请填写退款金额', trigger: 'blur'},
              {pattern: /^\d+(\.\d{1,2})?$/, message: '实退金额不正确，(纯数字，最多保留两位小数)', trigger: 'blur'},
              {type: 'string', max: 9, message: '退款金额超出限定', trigger: 'blur'}
            ],
            reason: [
              {required: true, message: '请填写退款原因', trigger: 'blur'},
              {type: 'string', max: 200, message: '备注长度不能超过200个字符', trigger: 'blur'}
            ]
          }
        },
        cancelModal: {
          display: false,
          data: {
            id: "",
            sourceId: "",
            remark: "",
            tips1: '确定取消退款单？ 取消后将恢复订单账务',
            tips2: '该操作不可恢复，请谨慎操作'
          },
          defaultData: {
            id: "",
            sourceId: "",
            remark: "",
            tips1: '确定取消退款单？ 取消后将恢复订单账务',
            tips2: '该操作不可恢复，请谨慎操作'
          },
          validate: {
            remark: [
              {required: true, message: '请填写退款原因', trigger: 'blur'},
              {type: 'string', max: 200, message: '备注长度不能超过200个字符', trigger: 'blur'}
            ],
            tips1: [
              {required: true, message: '请填写退款原因', trigger: 'blur'},
            ],
            tips2: [
              {required: true, message: '请填写退款原因', trigger: 'blur'},
            ]
          }
        }
      },
      search: {
        "startDate": Moment().subtract(7,'days').format('YYYY-MM-DD'),
        "endDate": Moment().format('YYYY-MM-DD'),
        "page": 1,
        "size": "10",
        "orderNo": "",
        "refundStat": 0,
        "refundType": 0,
        "refundRea": 0,
        "refundWay": 0
      },
      refund: {
        list: [],
        count: 0,
        page: 1,
        pageSize: 10
      },
      column: [
        {
          title: "订单号",
          key: "orderNo",
          align: "center",
          width: 210,
        },
        {
          title: "支付单号",
          key: "payNo",
          align: "center",
          width: 200
        },
        {
          title: "支付单信息",
          width: 270,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `支付时间：${params.row.payDate}`),
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `支付方式：${params.row.payType}`),
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `支付金额：${params.row.price}`),
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `流水号：${params.row.bankNo}`),
            ]);
          }
        },
        {
          title: "创建时间",
          key: "createdAt",
          width: 120,
          align: "center",
        },
        {
          title: "退款单号",
          key: "refundNo",
          width: 210,
          align: "center",
        },
        {
          title: "退款金额",
          key: "refundAmout",
          width: 200,
          align: "center",
        },
        {
          title: "退款类型",
          key: "refundType",
          width: 200,
          align: "center",
        },
        {
          title: "退款原因",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, params.row.createType),
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, params.row.refundReason),
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `操作人：${params.row.createBy}`)
            ]);
          }
        },
        {
          title: "退款状态",
          key: "stat",
          width: 200,
          align: "center",
        },
        {
          title: "退款方式",
          key: "refundChannel",
          width: 200,
          align: "center",
          render: (h,p) => {
            return h('span',{},['','Xbed原路退款','线下退款','OTA退款'][p.row.refundChannel] || ' - ')
          }
        },
        {
          title: "收款账户",
          width: 200,
          align: "center",
          render: (h, params) => {
            if(params.row.receiveSourceName=="银联"){
              return h("div", [
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`方式：${params.row.receiveSourceName}`),
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`银行：${params.row.bankName}`),
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`账号：${params.row.receiveAccount}`)
              ]);
            }else{
              return h("div", [
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`方式：${params.row.receiveSourceName}`),
                h('p',{
                  style: {
                    textAlign: "left"
                  }
                },`账号：${params.row.receiveAccount}`)
              ]);
            }
          }
        },
        {
          title: "实退金额",
          key: "activeMoney",
          width: 200,
          align: "center",
        },
        {
          title: "备注",
          key: "updatedAt",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `操作时间：${params.row.updatedAt}`),
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `操作人： ${params.row.updateBy}`),
              h('p', {
                style: {
                  textAlign: "left"
                }
              }, `备注：${params.row.remark}`)
            ]);
          }
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          render: (h, params) => {
            if(params.row.stat == "待退款"){
              return h('div',[
                h('Button',{
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.modalCtrEvent('refundModal',params.row);
                    }
                  }
                },'手动退款'),
                h('Button',{
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.modalCtrEvent('cancelModal',params.row);
                    }
                  }
                },'取消')
              ])
            }
          }
        }
      ],
      validateStatus: false
    }
  },
  methods: {
    addNewRefund() {
      this.modalCtrEvent('addRefundModal',null);
    },
    changePage(pageIndex) {
      this.search.page = pageIndex;
      this.queryRefundsList();
    },
    changePageSize(pageSize) {
      this.search.page = 1;
      this.search.size = pageSize;
      this.queryRefundsList();
    },
    conditionSearch() {
      this.search.page = 1;
      this.search.startDate = Moment(this.defaultDate[0]).format("YYYY-MM-DD");
      this.search.endDate = Moment(this.defaultDate[1]).format("YYYY-MM-DD");
      this.queryRefundsList();
    },
    modalCtrEvent(name,obj) {
      this.modalCtr[name].display = true;
      if(obj){
        Object.keys(this.modalCtr[name].data).forEach(value => {
          obj[value] && (this.modalCtr[name].data[value] = obj[value]);
        });
        this.modalCtr[name].data.refundChannel && (this.modalCtr[name].data.refundChannel = "1");
        this.modalCtr[name].data.remark && (this.modalCtr[name].data.remark = "");
      }
    },
    //手动退款
    async subRefundInfo() {
      let params = Object.assign({},this.modalCtr.refundModal.data);
      this.$refs.refundModal.buttonLoading = false;
      if(params.changeMoney == 1){
        params.activeMoney = params.refundAmout
      }else {
        if (params.activeMoney === '') { 
          this.$Notice.error({
            title: '请填写实退金额'
          });
          return; 
        }
        if (!/^\d+(\.\d{1,2})?$/.test(params.activeMoney) ) {
          this.$Notice.error({
            title: '实退金额不正确，最多保留两位小数'
          });
          return;
        }
        if (params.activeMoneyInt > params.refundAmoutInt) {
          this.$Notice.error({
            title: '实退金额不能大于本退款单可退金额'
          });
          return;
        }
      }
      params.activeMoneyInt = parseInt(params.activeMoney*100);
      params.refundAmoutInt = parseInt(params.refundAmout*100);
      if(params.refundChannel!="2"){
        params.receiveSource = "";
        params.aliPay = "";
        params.bankName = "";
        params.bankCount = "";
        params.bankName = "";
        params.receiveAccount = '';
      }else{
        switch (params.receiveSource) {
          case "微信":
            break;
          case '支付宝':
            if (params.aliPay === '') { 
              this.$Notice.error({
                title: '请输入支付宝账号'
              });
              return; 
            }
            if (/.*[\u4e00-\u9fa5]+.*$/.test(params.aliPay)) { 
              this.$Notice.error({
                title: '支付宝账号不正确'
              });
              return; 
            }
            if (params.aliPay.length > 60) { 
              this.$Notice.error({
                title: '支付宝账号超出长度'
              });
              return; 
            }
            params.receiveAccount = params.aliPay;
            break;
          case '银联':
            if (params.bankName === '') { 
              this.$Notice.error({
                title: '请输入银行名称'
              });
              return; 
            }
            if (params.bankCount === '') { 
              this.$Notice.error({
                title: '请输入银行卡号'
              });
              return; 
            }
            if (!/^\d{16,21}$/.test(params.bankCount)) { 
              this.$Notice.error({
                title: '银行卡号不正确，16-21位'
              });
              return; 
            }
            if (params.bankName.length > 60) { 
              this.$Notice.error({
                title: '银行名称超出长度'
              });
              return; 
            }
            if (params.bankCount.length > 60) { 
              this.$Notice.error({
                title: '银行卡号超出长度'
              });
              return; 
            }
            params.receiveAccount = params.bankCount;
            break;
          case '线下':
            break;
        }
      }
      if (params.remark === '') { 
        this.$Notice.error({
          title: '请填写备注'
        });
        return;
      }
      if (params.remark.length > 250) { 
        this.$Notice.error({
          title: '备注长度不能超过250个字符'
        });
        return;
      }
      //调用手动退款接口
      let resp = await this.requestJson(params,'confirmRefund')
      if (resp.retCode != 21020000) {
        this.$Notice.error({
          title: "手动退款失败",
          desc: resp.msg
        });
        return;
      }
      this.$Notice.success({
        title: "退款成功"
      });
      this.modalCtr.refundModal.display = false;
      this.modalCtr.refundModal.data = this.deepCopy(this.modalCtr.refundModal.defaultData);
      this.queryRefundsList();
    },
    async subNewRefund() {
      this.validateForm('addNewRefundForm');
      if(this.validateStatus){
        let params = this.modalCtr.addRefundModal.data;
        params.priceInt = parseInt(params.price*100);
        //调用新增退款单接口
        let resp = await this.requestJson(params,'createRefund');
        if (resp.retCode != 21020000) {
          this.$Notice.error({
            title: resp.msg,
          });
          return;
        }
        this.$Notice.success({
          title: "新建退款单成功",
        });
        this.modalCtr.addRefundModal.display = false;
        this.modalCtr.addRefundModal.data = this.deepCopy(this.modalCtr.addRefundModal.defaultData);
        this.queryRefundsList();
      }
      this.$refs.addRefundModal.buttonLoading = false;
    },
    async  subCancel() {
      this.validateForm('cancelRefundForm');
      if(this.validateStatus){
        let params = Object.assign({},this.modalCtr.cancelModal.data);
        delete params.tips1;
        delete params.tips2;
        let resp = await this.requestJson(params,'cancelRefund');
        if (resp.retCode != 21020000) {
          this.$Notice.error({
            title: '取消失败',
            desc: resp.msg || resp.retmsg,
          });
          return;
        }
        this.$Notice.success({
          title: "取消成功",
        });
        this.modalCtr.cancelModal.display = false;
        this.modalCtr.cancelModal.data = this.deepCopy(this.modalCtr.cancelModal.defaultData);
        this.queryRefundsList();
      }
       this.$refs.cancelModal.buttonLoading = false;
    },
    validateForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.validateStatus = true;
        } else {
          this.validateStatus = false;
        }
      })
    },
    deepCopy(obj) {
      return Object.assign({},obj);
    },
    exportExcel() {
      let params = {
        "startDate": this.search.startDate,
        "endDate": this.search.endDate,
        "page": 1,
        "size": 100000000,
        "orderNo": this.search.orderNo,
        "refundStat": this.search.refundStat || "",
        "refundType": this.search.refundType || "",
        "refundRea": this.search.refundRea || "",
        "refundWay": this.search.refundWay || ""
      }
      //调用php接口
      let url = `${Config[this.env].phpUrl}Interface/index.php/Home/Reserve/queryRefundsByDateExcelData?json_data=${JSON.stringify(params)}`;
      // window.open(url);
      Utils.exportExcelWeighting( url, this.token, this.$Notice.error )
    },
    async queryRefundsList() {
      let params = {
        "startDate": this.search.startDate,
        "endDate": this.search.endDate,
        "page": this.search.page,
        "size": this.search.size,
        "orderNo": this.search.orderNo,
        "refundStat": this.search.refundStat || "",
        "refundType": this.search.refundType || "",
        "refundRea": this.search.refundRea || "",
        "refundWay": this.search.refundWay || ""
      }
      let resp = await this.requestJson(params, 'refundsList');
      if (resp.retCode != 21020000) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.msg
        });
        return;
      }
      this.$Notice.success({
        title: "查询成功"
      })
      this.refund.list = resp.data.result;
      this.refund.count = resp.data.count;
      this.refund.page = resp.data.page;
      this.refund.pageSize = resp.data.pageCount;
    },
    async requestJson(params,apiName) {
      return (await API.omsAPI[this.env].php[apiName](
        params,
        this.token
      )).data;
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/pages/order/refunds-list.vue